import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Tab, TableCell, Tabs, TextField, Typography } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from 'mui-datatables';
import AddIcon from '@material-ui/icons/Add';
import CloseImage from '../../assets/ic_delete.png';
import IconArrow from '../../assets/ic_arrow.png';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import { format } from 'date-fns';
import Loader from 'react-loader-spinner'
import ic_detail from '../../assets/1@3x.png';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTablePemanggilan());

const options = ct.customOptions()

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function PengambilanHasil(props) {
    const classes = useStyles()
    const [noAntri, setNoAntri] = React.useState("");
    const [namaPasien, setNamaPasien] = React.useState("")
    const [kodePesanan, setKodePesanan] = React.useState("")
    const [notes, setNotes] = React.useState("")
    const [newNotes, setNewNotes] = React.useState("")
    const [waktu, setWaktu] = React.useState(new Date())
    const [value, setValue] = React.useState(0);
    const [visible, setVisible] = React.useState(false)
    const [addCatatan, setAddCatatan] = React.useState(false)
    const [listLokasi] = React.useState([
        { nama: 'Counter A' },
    ])
    const [lokasi, setLokasi] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [dataAntrian, setDataAntrian] = React.useState([])
    const [rawData, setRawData] = React.useState([])
    const [statusAntrian, setStatusAntrian] = React.useState("")

    const [facility_id, setFacilityID] = React.useState("")
    const [facility_queue_id, setFacilityQueueID] = React.useState("")
    const [loading, setLoading] = React.useState(false)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const wrapperRef = React.createRef()

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }

    useEffect(() => {
        getDataAntrian()
        setLoading(true)
    }, [])

    const getDataAntrian = () => {
        api.create().getPemanggilanFacility(8).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data) {

                    let dataAntrian = response.data.data.map((item, index) => {
                        return [
                            item.queue_number,
                            item.facility_location,
                            // item.room_name,
                            item.notes,
                            item.patient_id,
                            item.facility_id,
                            item.facility_queue_id,
                        ]
                    })
                    console.log(response.data.data);
                    setDataAntrian(dataAntrian)
                    setLoading(false)
                    if (response.data.data.length > 0) {
                        setRawData(response.data.data[0])
                        if (response.data.data[0].queue_status_name === 'Process') {
                            let queueID = response.data.data[0].facility_queue_id
                            api.create().getDetailPemanggilanFacility(queueID).then(response => {
                                if (response.data) {
                                    if (response.data.data) {
                                        console.log(response);
                                        let data = response.data.data
                                        let a = new Date()
                                        let year = format(a, 'yyyy-MM-dd')
                                        let jam = (`${year}T${data.estimated_time}:00+07:00`)
                                        setWaktu(Date.parse(jam))
                                        setNoAntri(data.queue_number)
                                        setKodePesanan(data.booking_id)
                                        setNamaPasien(data.patient_name)
                                        setNotes(data.notes)
                                        setFacilityQueueID(data.facility_queue_id)
                                        setFacilityID(data.facility_id)
                                        setStatusAntrian("Proses")
                                        forceUpdate()
                                    }
                                }
                            })
                        }
                    }
                }
            }
        })
    }

    const handleNextPatient = () => {
        setLoading(true)
        if (rawData.queue_status_name === "New") {
            let payload = {
                "facility_id": rawData.facility_id,
                "facility_queue_id": null,
                "status": "NEXT"
            }
            api.create().updateListPemanggilanFacility(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        let data = response.data.data
                        let a = new Date()
                        let year = format(a, 'yyyy-MM-dd')
                        let jam = (`${year}T${data.estimated_time}:00+07:00`)
                        setWaktu(Date.parse(jam))
                        setNoAntri(data.queue_number)
                        setKodePesanan(data.booking_id)
                        setNamaPasien(data.patient_name)
                        setNotes(data.notes)
                        setFacilityQueueID(data.facility_queue_id)
                        setFacilityID(data.facility_id)
                        setStatusAntrian("Next")
                        setTimeout(() => {
                            setLoading(false)
                        }, 500);
                        forceUpdate()
                    }
                }
            })
        }
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleStart = () => {
        setLoading(true)
        let payload = {
            "facility_id": facility_id,
            "facility_queue_id": facility_queue_id,
            "status": "START"
        }
        api.create().updateListPemanggilanFacility(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setTimeout(() => {
                        setLoading(false)
                    }, 300);
                    setStatusAntrian("Proses")
                }
            }
        })
    }

    const handleStop = () => {
        setLoading(true)
        let payload = {
            "facility_id": facility_id,
            "facility_queue_id": facility_queue_id,
            "status": "DONE"
        }
        api.create().updateListPemanggilanFacility(payload).then(response => {
            setTimeout(() => {
                setLoading(false)
            }, 300);
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    setNoAntri("")
                    setKodePesanan("")
                    setNamaPasien("")
                    setNotes("")
                    getDataAntrian()
                }
            }
            console.log(response);
        })
    }

    const handleSkip = ({ rowData }) => {
        setLoading(true)
        let payload = {
            "facility_id": rowData[4],
            "facility_queue_id": rowData[5],
            "status": "SKIP"
        }
        api.create().updateListPemanggilanFacility(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    // let data = response.data.data
                    // let a = new Date()
                    // let year = format(a, 'yyyy-MM-dd')
                    // let jam = (`${year}T${data.estimated_time}:00+07:00`)
                    // setWaktu(Date.parse(jam))
                    // setNoAntri(data.queue_number)
                    // setKodePesanan(data.booking_id)
                    // setNamaPasien(data.patient_name)
                    // setNotes(data.notes)
                    // setFacilityQueueID(data.facility_queue_id)
                    // setFacilityID(data.facility_id)
                    // setStatusAntrian("")
                    getDataAntrian()
                    setTimeout(() => {
                        setLoading(false)
                    }, 500);
                    // forceUpdate()
                }
            }
        })
    }

    const handleCall = ({ rowData }) => {
        setLoading(true)
        let payload = {
            "facility_id": rowData[4],
            "facility_queue_id": rowData[5],
            "status": "CALL"
        }
        console.log(rowData);
        api.create().updateListPemanggilanFacility(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let a = new Date()
                    let year = format(a, 'yyyy-MM-dd')
                    let jam = (`${year}T${data.estimated_time}:00+07:00`)
                    setWaktu(Date.parse(jam))
                    setNoAntri(data.queue_number)
                    setKodePesanan(data.booking_id)
                    setNamaPasien(data.patient_name)
                    setNotes(data.notes)
                    setFacilityQueueID(data.facility_queue_id)
                    setFacilityID(data.facility_id)
                    setStatusAntrian("")
                    setTimeout(() => {
                        setLoading(false)
                    }, 500);
                    forceUpdate()
                }
            }
        })
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const data = [
        {No: 1}
    ]

    const columns = [
        "No", "No Antrian", "Kode Pesanan", "Nama Pasien", "Status",
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ width: 500 }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <button
                                style={{ outline: 'none', borderColor: 'transparent', backgroundColor: 'transparent', width: 100 }}
                                onClick={() => {
                                    handleCall(tableMeta)
                                }}
                            >
                                <img src={ic_detail} style={{width: 30, height: 30}} />
                            </button>
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

    return (
        <div>
            <Paper style={{ boxShadow: 'none' }} >
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                    style={{ outline: 'null' }}
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    <Tab label="Cito" style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                    <Tab label="Poli" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} />
                </Tabs>
            </Paper>
            {value === 0 ?
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', padding: 10, zIndex: 1 }} >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </Paper>
                : null
            }
        </div>
    )
}